export default __webpack_public_path__ + "static/media/de.bd4499b6.svg";